// API Configuration
export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_URL || (import.meta.env.DEV ? 'http://localhost:5000/api' : 'https://gandimall.onrender.com/api'),
  TIMEOUT: 10000, // 10 seconds
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000, // 1 second
};

// Environment check
export const isDevelopment = import.meta.env.DEV;
export const isProduction = import.meta.env.PROD;

// API endpoints
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    ME: '/auth/me',
    REGISTER: '/auth/register',
  },
  SHOPS: {
    LIST: '/shops',
    DETAIL: (id: string) => `/shops/${id}`,
    CREATE: '/shops',
    UPDATE: (id: string) => `/shops/${id}`,
    DELETE: (id: string) => `/shops/${id}`,
    AVAILABLE: '/shops/available',
    SEARCH: '/shops/search',
    STATISTICS: '/shops/statistics/overview',
  },
  APPLICATIONS: {
    LIST: '/applications',
    DETAIL: (id: string) => `/applications/${id}`,
    CREATE: '/applications',
    UPDATE_STATUS: (id: string) => `/applications/${id}/status`,
    DELETE: (id: string) => `/applications/${id}`,
    SEARCH: '/applications/search',
    EXPORT: '/applications/export',
    STATISTICS: '/applications/statistics',
  },
  ADMIN: {
    DASHBOARD: '/admin/dashboard',
    SETTINGS: '/admin/settings',
    LOGS: '/admin/logs',
    BACKUP: '/admin/backup',
    HEALTH: '/admin/health',
    ACTIVITY: '/admin/activity',
  },
  HEALTH: '/health',
};
